<template>
    <main-content with_go_back_bar>
        <create-factor-form>
        </create-factor-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import Form from './components/form_factor'


    export default {
        components: {
            'main-content': mainContent,
            'create-factor-form': Form
        },
    }
</script>
